/* Subscription client data model
 *
 * 
 */

import makePropsEnumerable from "../utility/MakePropsEnumerable";

const subscriptionTypesMap = new Map();
subscriptionTypesMap.set("Target", "Target");
subscriptionTypesMap.set("StateId", "State Office");
subscriptionTypesMap.set("Office", "Office");
subscriptionTypesMap.set("Election", "Election");
subscriptionTypesMap.set("OfficeType", "Office Type");
subscriptionTypesMap.set("StateEvent", "State Event");

const realTimeSubscriptionTypeName = "Real Time";

class Subscription {
    constructor(
        subscriptionId,
        subscriptionTargetId,
        subscriptionType,
        subscriptionFrequency,
        subscriptionTargetUrl,
        subscriptionTargetData
    )
    {
        if ((subscriptionId !== undefined) &&
            (subscriptionId != null) &&
            (Number.isFinite(subscriptionId)))
        {
            this.subscriptionId = subscriptionId;
        }
        else {
            throw new TypeError("Null or missing subscription id.");
        }
    
        if ((subscriptionTargetId !== undefined) &&
            (subscriptionTargetId != null) &&
            (Number.isFinite(subscriptionTargetId)))
        {
            this.subscriptionTargetId = subscriptionTargetId;
        }
        else {
            throw new TypeError("Null or missing subscription target id.");
        }
    
        if ((subscriptionType !== undefined) &&
            (subscriptionType != null) &&
            (angular.isString(subscriptionType)))
        {
            //TODO: Validate that subscription type is known value.
            this.subscriptionType = subscriptionType;
        }
        else {
            throw new TypeError("Null or missing subscription type name.");
        }
    
        if ((subscriptionFrequency !== undefined) &&
            (subscriptionFrequency != null) &&
            (angular.isString(subscriptionFrequency)))
        {
            this.subscriptionFrequency = subscriptionFrequency;
        }
        else {
            throw new TypeError("Null or missing subscription frequency.");
        }
    
        this.subscriptionTargetUrl = null;
        if ((angular.isDefined(subscriptionTargetUrl)) &&
            (subscriptionTargetUrl != null) &&
            (angular.isString(subscriptionTargetUrl)))
        //TODO: Maybe- strip off scheme/host/port.
        // Will later be combined with api-server-location,
        // to prevent us making calls elsewhere.
        {
            this.subscriptionTargetUrl = subscriptionTargetUrl;
        }
    
        this.subscriptionTargetData = new Map();
        if ((angular.isDefined(subscriptionTargetData)) &&
            (subscriptionTargetData != null))
        {
            Object.keys(subscriptionTargetData).forEach((targetKey) => {
                this.subscriptionTargetData.set(
                    targetKey,
                    subscriptionTargetData[targetKey]
                );
            });
        }
    }

    toString() {
        return this.subscriptionType + "/" +
            this.subscriptionTargetId + "/" +
            String(this.subscriptionId);
    }
    
    valueOf() {
        return this.subscriptionId;
    }

    get hasSubscriptionTargetName() {
        return (this.subscriptionTargetData.size > 0);
    }

    _makeTrackingTargetName() {
        let trackingTargetFirstName = this.subscriptionTargetData.get("TargetFirstName");
        let trackingTargetLastName = this.subscriptionTargetData.get("TargetLastName");
        let subName = trackingTargetFirstName + " " + trackingTargetLastName;
        return subName;
    }

    _makeElectionName() {
        let electionYear = this.subscriptionTargetData.get("ElectionDateYear");
        let electionMonth = this.subscriptionTargetData.get("ElectionDateMonth");
        let electionDay = this.subscriptionTargetData.get("ElectionDateDay");
        // let electionTypeName = this.subscriptionTargetData.get("ElectionTypeName");
        let electionOfficeTypeName = this.subscriptionTargetData.get("ElectionOfficeTypeName");
        let electionOfficeDistrict = this.subscriptionTargetData.get("ElectionOfficeDistrict");
        let electionState = this.subscriptionTargetData.get("StateShortName");
        let electionDate = electionMonth + "/" + electionDay + "/" + electionYear;
    
        let electionName = [ electionDate, " ", electionOfficeTypeName, " (" ];
    
        if (electionOfficeTypeName !== "President") {
    
            electionName.push(electionState);
    
            if (electionOfficeTypeName === "House") {
                electionName.push("-");
                electionName.push(electionOfficeDistrict);
            }
    
            electionName.push(")");
        }
    
        let subName = electionName.join("");
        return subName;
    }

    _makeOfficeName() {
        let officeTypeName = this.subscriptionTargetData.get("OfficeTypeName");
        let officeDistrict = this.subscriptionTargetData.get("OfficeDistrict");
        let officeState = this.subscriptionTargetData.get("StateShortName");
    
        let officeName = [ officeTypeName, " (" ];
    
        if (officeTypeName !== "President") {
    
            officeName.push(officeState);
    
            if (officeTypeName === "House") {
                officeName.push("-");
                officeName.push(officeDistrict);
            }
    
            officeName.push(")");
        }
    
        let subName = officeName.join("");
        return subName;
    }

    get subscriptionTargetName() {
        if (!this.hasSubscriptionTargetName) { return ""; }

        let subName = "";

        switch(this.subscriptionType) {
            case "Target":
                subName = this._makeTrackingTargetName();
                break;
            case "Election":
                subName = this._makeElectionName();
                break;
            case "Office":
                subName = this._makeOfficeName();
                break;
            case "StateId":
                subName = this.subscriptionTargetData.get("StateShortName");
                break;
            case "StateEvent":
                subName = this.subscriptionTargetData.get("StateShortName");
                break;
            case "OfficeType":
                subName = this.subscriptionTargetData.get("OfficeTypeName");
        }

        return subName;
    }

    static CopySubscription(otherSubscription) {

        if ((angular.isDefined(otherSubscription)) &&
            (otherSubscription != null)) {

            return new Subscription(
                otherSubscription.subscriptionId,
                otherSubscription.subscriptionTargetId,
                otherSubscription.subscriptionType,
                otherSubscription.subscriptionFrequency,
                otherSubscription.subscriptionTargetUrl
            );
        }
        else {
            return null;
        }
    }
    
    static FromServerSubscription(serverSubscription) {

        if ((serverSubscription !== undefined) &&
            (serverSubscription != null))
        {

            let serverSubscriptionTargetUrl = null;
            let subTargetLinks = serverSubscription.Links.filter(function(lnk) {
                return (lnk.Rel === "self");
            });

            if (subTargetLinks.length === 0) {
                serverSubscriptionTargetUrl = subTargetLinks[0].Href;
            }

            return new Subscription(
                serverSubscription.SubscriptionId,
                serverSubscription.SubscriptionTargetId,
                serverSubscription.SubscriptionType,
                serverSubscription.SubscriptionFrequency,
                serverSubscriptionTargetUrl,
                serverSubscription.SubscriptionTargetData
            );
        }

        else {
            return null;
        }

    }

    static GetSubscriptionTypes() {
        return {
            Target: "Target",
            StateId: "State Office",
            Office: "Office",
            Election: "Election",
            OfficeType: "Office Type",
            StateEvent: "State Event"
        };
    }

    static GetSubscriptionTypeDisplayName(subTypeName) {
        return subscriptionTypesMap.get(subTypeName);
    }

    static get realTimeSubscriptionTypeName() {
        return realTimeSubscriptionTypeName;
    }
}

makePropsEnumerable(Subscription.prototype, [
    "hasSubscriptionTargetName",
    "subscriptionTargetName"
]);

export default Subscription;



//////////////////
// WEBPACK FOOTER
// ./src/models/Subscription.js
// module id = b9nq
// module chunks = 1